<template>
  <b-card>
    <b-row>
      <b-col md="12">
        <h3>Usuários</h3>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <b-form-group label="Nome, E-mail ou CPF:">
          <b-form-input type="text" id="name" v-model="filtro.nomeEmailCPF"></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row align-v="center">
      <b-col sm="4">
        <b-form-group label="Perfil:">
          <b-form-select v-model="filtro.perfil" :options="perfis"></b-form-select>
        </b-form-group>
      </b-col>
      <b-col sm="4">
        <b-row align-h="center">
          <b-form-group label="Conferência:">
            <b-form-select v-model="filtro.conferencia" :options="conferencias"></b-form-select>
          </b-form-group>
        </b-row>
      </b-col>
      <b-col sm="4">
        <b-row align-h="center">
          <b-form-group label="Status:">
            <b-form-radio-group v-model="filtro.ativo" :options="status" required/>
          </b-form-group>
        </b-row>
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="2">
        <b-button block @click="limpar">
          <i class="fa fa-eraser"></i>&nbsp;&nbsp;<span>Limpar filtros</span>
        </b-button>
      </b-col>
      <b-col sm="2">
        <b-button block variant="primary" @click="carregar">
          <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
        </b-button>
      </b-col>
    </b-row>
    <b-row><b-col>&nbsp;</b-col></b-row>
    <b-row>
      <b-col>
        <b-table id="usuarios" :fields="campos" :items="usuarios" :per-page="totalPorPagina" :current-page="paginaAtual" small bordered outlined>
          <template #cell(cpf)="data">{{aplicarMascara(data.item.cpf)}}</template>
          <template #cell(ativo)="data">{{data.item.ativo ? 'Ativo' : 'Inativo'}}</template>
          <template #cell(perfis)="data">{{stringify(data.item.perfis, 'id', 'nome')}}</template>
          <template #cell(conferencias)="data">{{stringify(data.item.conferencias, 'conferencia_id', 'conferencia_nome')}}</template>
          <template #cell(super_usuario)="data">{{data.item.super_usuario ? 'Sim' : 'Não'}}</template>
          <template #cell(id)="data">
            <b-row no-gutters>
              <b-col>
                <b-row no-gutters align-h="end">
                  <b-link title="Visualizar" @click="navigate('/usuario/' + data.item.id + '/visualizar')">
                    <i class="fa fa-search" style="color: black"/>
                  </b-link>&nbsp;
                  <b-link title="Vincular" @click="navigate('/usuario/vincular/' + data.item.id)">
                    <i class="fa fa-link" style="color: black"/>&nbsp;
                  </b-link>&nbsp;
                  <b-link title="Super Usuário" @click="alternarSuperUsuario(data.item.id)">
                    <i class="fa fa-user-plus" style="color: black"/>&nbsp;
                  </b-link>
                </b-row>
              </b-col>
              <b-col>
                <b-form-checkbox v-model="data.item.ativo" @change="alternarAtivo(data.item.id)" v-b-popover.hover.right="data.item.ativo ? 'Desativar' : 'Ativar'" switch style="width:45px"/>
              </b-col>
            </b-row>
          </template>
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col><b-pagination v-model="paginaAtual" :total-rows="usuarios.length" :per-page="totalPorPagina" aria-controls="usuarios" v-show="usuarios.length > 0"/></b-col>
    </b-row>
    <b-row>
      <b-col>Exibindo página {{paginaAtual}} de {{Math.floor(usuarios.length / totalPorPagina) + (usuarios.length % totalPorPagina > 0 ? 1 : 0)}}, total de {{usuarios.length}} registro{{usuarios.length > 1 ? 's' : ''}}.</b-col>
    </b-row>
  </b-card>
</template>

<script>
import Vue from 'vue'

export default {
  data () {
    return {
      totalPorPagina: 10,
      paginaAtual: 1,
      filtro: {
        nomeEmailCPF: null,
        ativo: null,
        perfil: null,
        conferencia: null
      },
      status: [
        {value: true, text: 'Ativo'},
        {value: false, text: 'Inativo'}
      ],
      usuarios: [],
      campos: [
        {key: 'cpf', label: 'CPF', sortable: false},
        {key: 'nome', label: 'Nome do Usuário', sortable: false},
        {key: 'ativo', label: 'Status', sortable: false},
        {key: 'perfis', label: 'Perfil', sortable: false},
        {key: 'conferencias', label: 'Conferência', sortable: false},
        {key: 'super_usuario', label: 'Super usuário?', sortable: false},
        {key: 'id', label: 'Ações', sortable: false, tdClass: 'centro', thClass: 'centro'}
      ],
      perfis: [],
      conferencias: []
    }
  },
  mounted () {
    this.carregar()
    this.carregarPerfis()
    this.carregarConferencias()
  },
  methods: {
    navigate (route) {
      this.$router.push(route)
    },
    carregar () {
      let cpf = this.filtro.nomeEmailCPF

      if (cpf && cpf.match(/\d{3}\.\d{3}\.\d{3}-\d{2}/g)) {
        while (cpf.indexOf('.') >= 0) {
          cpf = cpf.replace('.', '')
        }
        cpf = cpf.replace('-', '')
      }

      let filtro = {nomeEmailCPF: cpf, ativo: this.filtro.ativo, perfil: this.filtro.perfil, conferencia: this.filtro.conferencia}

      Vue.http.post('api/usuario/buscar', filtro).then(response => {
        if (response.body.success) {
          this.usuarios = response.body.data
        }
      })
    },
    carregarPerfis () {
      Vue.http.post('api/perfil/index', {status: true}).then(response => {
        if (response.body.success) {
          let perfis = response.body.data

          for (let i = 0; i < perfis.length; i++) {
            this.perfis.push({value: perfis[i].id, text: perfis[i].nome})
          }
        }
      })
    },
    carregarConferencias () {
      Vue.http.post('api/conferencia/buscar', {}).then(response => {
        if (response.body.success) {
          let conferencias = response.body.data

          for (let i = 0; i < conferencias.length; i++) {
            this.conferencias.push({value: conferencias[i].id, text: conferencias[i].nome})
          }
        }
      })
    },
    stringify (items, id, campo) {
      let lista = []

      for (let i = 0; i < items.length; i++) {
        let index = -1

        for (let j = 0; j < lista.length && index === -1; j++) {
          index = lista[j][id] === items[i][id] ? j : -1
        }

        if (index === -1) {
          lista.push(items[i])
        }
      }

      let result = ''

      for (let i = 0; i < lista.length; i++) {
        result += (i > 0 ? ', ' : '') + lista[i][campo]
      }

      return result
    },
    sucesso (mensagem) {
      this.$bvToast.toast(mensagem, {
        title: 'Sucesso',
        autoHideDelay: 10000,
        appendToast: true,
        variant: 'info'
      })
    },
    alternarAtivo (id) {
      let index = -1

      for (let i = 0; i < this.usuarios.length && index === -1; i++) {
        index = this.usuarios[i].id === id ? i : -1
      }

      let mensagem = this.usuarios[index].ativo ? 'Tem certeza que deseja ativar este registro?' : 'Tem certeza que deseja desativar este registro?'

      this.$bvModal.msgBoxConfirm(mensagem, {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          if (this.usuarios[index].ativo) {
            Vue.http.get('api/usuario/ativar/' + id)
            this.sucesso('Usuário ativado com sucesso.')
          } else {
            Vue.http.get('api/usuario/suspender/' + id)
            this.sucesso('Usuário desativado com sucesso.')
          }
        } else {
          this.usuarios[index].ativo = !this.usuarios[index].ativo
        }
      })
    },
    alternarSuperUsuario (id) {
      let index = -1

      for (let i = 0; i < this.usuarios.length && index === -1; i++) {
        index = this.usuarios[i].id === id ? i : -1
      }

      let mensagem = this.usuarios[index].super_usuario ? 'Tem certeza que deseja desclassificar esse usuário?' : 'Tem certeza que deseja tornar esse usuário um Super Usuário?'

      this.$bvModal.msgBoxConfirm(mensagem, {
        noCloseOnBackdrop: true,
        centered: true,
        okTitle: 'Confirmar',
        cancelTitle: 'Cancelar'
      }).then(valor => {
        if (valor) {
          Vue.http.get('api/usuario/switchSuperUser/' + id)
          this.usuarios[index].super_usuario = !this.usuarios[index].super_usuario

          if (this.usuarios[index].super_usuario) {
            this.sucesso('Usuário promovido a Super Usuário com sucesso.')
          } else {
            this.sucesso('Usuário desclassificado com sucesso.')
          }
        }
      })
    },
    limpar () {
      this.filtro = {nomeEmailCPF: null, ativo: null, perfil: null, conferencia: null}
      this.carregar()
    },
    aplicarMascara (numero) {
      return numero.substr(0, 3) + '.' + numero.substr(3, 3) + '.' + numero.substr(6, 3) + '-' + numero.substr(9)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuarios/Usuarios.vue